import { Fade } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import { TextsProps } from "../../../database/txt.interface";
import { AddPacAvalActions } from "../../../store/ducks/add_pac_aval";
import { AppActions } from "../../../store/ducks/app";
import { TypesErrorRequest } from "../../../utils/types";
import FotoPerfilMenor from "../../FotoPerfilMenor";
import ToastAlert from "../../toast";
import { Conteiner } from "./styles";
import { AmplitudeLog } from "../../../utils/amplitude";
import { DashBoardActions } from "../../../store/ducks/dashboard";
import Form from "../../Form";
import FormSubmiteButton from "../../Buttons/FormSubmitButton";
import { FormHandles } from "@unform/core";
import InputTextEntryForm from '../../../components/Inputs/inputForm';
import {ReactComponent as Fechar} from "../../../assets/icons/fechar.svg";


const AdicionarAvaliador = () => {
	const dispatch = useDispatch();
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);

	const is_open = useSelector(
		(state: any) => state.app.is_open_adicionar_avaliador
	);
	const load = useSelector(
		(state: any) => state.app.load_new_evaluator_or_patient
	);

	let photo = useSelector((state: any) => state.add_pac_aval.photo);

	const ModalAdicionarPacienteClose = () => {
		dispatch(AppActions.set_modal_adicionar_avaliador(false));
		dispatch(AppActions.set_load_add_evaluator_or_patient(false))
	};

	const [isAdm, setIsAdm] = useState(false);


	const methods = useForm();
	const formRef = useRef<FormHandles>(null);

	const onSubmit = (data: any) => {
		if (photo === undefined) {
			photo = null;
		}
		const dat_request = {
			USUARIO_NIVEL: isAdm? "1" : "2",
			USUARIO_NOME: methods.getValues('nome'),
			USUARIO_EMAIL: methods.getValues('emailAvaliador'),
			USUARIO_CONTATO: methods.getValues('celularAvaliador'),
			USUARIO_CPF: methods.getValues('cpfAvaliador'),
			
		};
		AmplitudeLog('avaliador_criado', {
			body: dat_request
		})
		dispatch(AddPacAvalActions.request_add_evaluetor(dat_request));
		dispatch(DashBoardActions.avaliadores_request());
	};

	const isValidFilds = () => {
		const { nome, emailAvaliador, celularAvaliador, cpfAvaliador } = methods.getValues();

		return [nome, emailAvaliador, celularAvaliador, cpfAvaliador]
			.every(value => Boolean(value?.trim()));
	};

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			modal: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
			paper: {
				backgroundColor: theme.palette.background.paper,
				border: "0",
				boxShadow: theme.shadows[5],
			},
		})
	);

	const classes = useStyles();

	const is_open_toast = useSelector((state: any) => state.app.is_open_toast);
	const type_toast = useSelector((state: any) => state.app.type_toast);

	useEffect(() => {
		if (type_toast == TypesErrorRequest.SUCCESS) {
			ModalAdicionarPacienteClose();
		}

	}, [is_open_toast]);

	useEffect(()=>{
		isValidFilds()
	},[methods.watch()]);

	useEffect(()=>{
		if(!is_open){
			methods.reset({
				nome: '',
				emailAvaliador: '',
				celularAvaliador: '',
				cpfAvaliador: ''
			})
		}
	},[is_open])



	return (
		<div>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				onClose={ModalAdicionarPacienteClose}
				open={is_open}
				closeAfterTransition
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={is_open}>
					<Conteiner>
						{is_open_toast && type_toast == TypesErrorRequest.FAIL ? (
							<ToastAlert />
						) : (
							""
						)}
							<div className={`flex w-full justify-end `}>
							<Fechar 
								className={`w-[18px] h-[18px] cursor-pointer mt-5`}
								onClick={()=>{
									ModalAdicionarPacienteClose() 
									AmplitudeLog('fechar_modal_novo_paciente')
							
								}}
							/>
						</div>
						<div className={`flex flex-col w-full items-center justify-center`}>
								<p className={`font-bold text-[#000E4B] text-2xl`}>Adicionar Avaliador</p>
								<div className={`w-auto self-center`}>
									<FotoPerfilMenor  />
								</div>
						</div>
						<Form  methods={methods} ref={formRef} 	onSubmit={(data)=>{onSubmit(data)}} className={`flex flex-col w-full h-full relative mt-3 }`}>
								<div className={`w-full flex flex-row`}>
									<div className={` flex flex-col w-1/2  `}>
										<InputTextEntryForm 
											type="text"
											width={95}
											title={'Nome completo' + '*'}
											placeholder={current_language?.placeholder_digite}
											fontFamily="NotoSans-SemiBold"
											fontWeight={600}
											marginTop={20}
											typeInputName="nome"
										/>
										
										<InputTextEntryForm 
											type="text"
											width={100}
											title={'CPF*'}
											placeholder={'__.____-__'}
											leftIcon="DigitalIcon"
											fontFamily="NotoSans-SemiBold"
											fontWeight={600}
											marginTop={20}
											typeInputName="cpfAvaliador"
										/>


									</div>
									<div className={` flex flex-col w-1/2`}>
										<InputTextEntryForm 
											type="text"
											width={100}
											title={'E-mail*'}
											placeholder={'Digite'}
											leftIcon="EmailIcon"
											fontFamily="NotoSans-SemiBold"
											fontWeight={600}
											marginTop={20}
											typeInputName="emailAvaliador"
										/>
										<InputTextEntryForm 
											type="text"
											width={100}
											title={'Celular*'}
											placeholder={'(DDD) 99999-9999'}
											leftIcon="Phone"
											fontFamily="NotoSans-SemiBold"
											fontWeight={600}
											marginTop={20}
											typeInputName="celularAvaliador"
										/>
										
									</div>
								</div>
								<div className={`flex flex-col w-full mt-5 items-start`}>
									<div className={`flex flex-row`}>
										<button
											type="button"
											onClick={() => setIsAdm(!isAdm)}
											className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors duration-300
												${isAdm ? "bg-[#000E4B]" : "bg-gray-500"}`}
										>
											<span
												className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300
													${isAdm ? "translate-x-5" : "translate-x-1"}`}
											/>
										</button>
										<p className={`ml-2 text-[#000E4B] font-semibold `}>
											{current_language?.add_avaliador}(a)
										</p>
									</div>
									<p className={`text-[#63677A]`}>
										As funções de administrador incluem gestão de assinaturas, pagamento e adicionar novos avaliadores.
									</p>
								</div>
					
								<div className={`flex w-full  absolute bottom-3 `}>
									<FormSubmiteButton
										type="submit"
										onClick={()=> {methods.trigger(), 
											dispatch(AppActions.set_load_add_evaluator_or_patient(true))
											setTimeout(()=>{dispatch(AppActions.set_load_add_evaluator_or_patient(false))},1000)
										}}
										disabled={ isValidFilds() ? false : true}
										marginTop={4}
										fontFamily="Kanit-Medium"
										typeButtonComponent="primary"
										title={ 'Salvar'}
										activityIndicator={load}
										activityIndicatorColor="#63677A"
									/>
								</div>
						</Form>
					</Conteiner>
				</Fade>
			</Modal>
		</div>
	);
};

export default AdicionarAvaliador;
